import routes from '@/modules/installment/routes'
import store from '@/modules/installment/store'

export default {routes, store}
